import { state } from "@src/state";
export const selectStudioIsLiveON = () => state.meeting.studio.stream.isLive;
export const selectStudioLiveStartTime = () => state.meeting.studio.stream.liveStartTime;
export const selectStudioVideoStream = () => state.meeting.studio.stream.videoStream;
